// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.

export { dividerClass } from "./landingPageConfig";

export const getPlacements = (page) =>
  (Array.isArray(page?.blocks) ? page.blocks : [])
    .filter((placement) => placement?.blockId)
    .slice()
    .sort((a, b) => (a?.position ?? 0) - (b?.position ?? 0));

// `position` decides the row: blocks sharing a position sit side by side, and a
// different position always starts a new row. Widths only size the columns, so
// a position whose widths exceed 100% shrinks to fit rather than splitting.
export const groupIntoRows = (placements) => {
  const rows = [];
  let row = [];
  let currentPosition;

  (placements || []).forEach((placement) => {
    const position = placement?.position ?? 0;

    if (row.length > 0 && position !== currentPosition) {
      rows.push(row);
      row = [];
    }

    currentPosition = position;
    row.push(placement);
  });

  if (row.length) rows.push(row);
  return rows;
};

export const filterCategories = (categories, term) => {
  const needle = (term || "").trim().toLowerCase();
  if (!needle) return categories || [];

  return (categories || [])
    .map((category) => ({
      ...category,
      dashboardIds: (category?.dashboardIds || []).filter((dashboard) =>
        dashboard?.label?.toLowerCase().includes(needle)
      ),
    }))
    .filter((category) => category.dashboardIds.length > 0);
};

export const isOthersCategory = (category, subscription) =>
  category?.label === `${subscription?.label}_Others`;

export const hasCategoryLabel = (category) => Boolean(category?.label?.trim());

// Categories whose label duplicates the product name in the rail, so the
// expanded sidebar skips the header and lists their dashboards directly.
const HIDDEN_CATEGORY_LABELS = [
  "market intelligence",
  "product intelligence",
  "network intelligence",
  "explainability",
  "resources",
];

export const isHiddenCategoryLabel = (category) =>
  HIDDEN_CATEGORY_LABELS.includes(category?.label?.trim().toLowerCase());
